import React from "react";
import MainLayout from "../../components/layouts/mainLayout";
import ContactInfoCard from "../../components/molecules/contactInfoCard";

const ContactInfo = () => {
  const background = "/assets/login/auth-bg.webp";

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "100% 100%, cover",
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1920px",
        }}
      >
        <MainLayout componentFlag="dashboard">
          <ContactInfoCard />
        </MainLayout>
      </div>
    </div>
  );
};

export default ContactInfo;
